const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer

class ProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupObservers()

    this.interval = setInterval(() => {
      this.checkYotpo()
    }, 200)
  }

  setupObservers () {
    if (this.coloursLoaded) return
    if (!this.productUrl) return
    if (!this.els.colours?.exists) return

    this.onEntry = this.onEntry.bind(this)

    this.observer = new IntersectionObserver(this.onEntry, {
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    observer.unobserve(this)

    this.fetchProductContent()
  }

  async fetchProductContent () {
    try {
      const response = await fetchSingleSection(
        'product-card-colours',
        this.productUrl,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)

      const coloursContent = newDOM.querySelector(
        '[data-product-card-colours-el="content"]',
      )

      if (!coloursContent) {
        this.coloursLoaded = true
        this.setupListeners()
        return
      }

      this.els.colours.element.innerHTML = coloursContent.outerHTML

      // Slight delay before updating attribute so transition happens correctly
      setTimeout(() => {
        this.coloursLoaded = true
        this.setupListeners()
      }, 50)
    } catch (error) {
      console.error(error)
    }
  }

  checkYotpo () {
    if (!window.yotpo) return

    clearInterval(this.interval)

    this.renderYotpoRating()
  }

  renderYotpoRating () {
    if (window.yotpo) {
      window.yotpo.initWidgets()

      setTimeout(() => {
        this.els.reviews?.element.setAttribute('aria-busy', 'false')
      }, 200)
    }
  }

  get coloursLoaded () {
    return this.dataset.coloursLoaded === 'true'
  }

  set coloursLoaded (value) {
    this.dataset.coloursLoaded = value
  }

  get productUrl () {
    return this.dataset.productUrl || ''
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}
